import axiosIns from '@/libs/axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchPaymentRemarks(ctx, queryParams) {
        return new Promise((resolve, reject) => {
          axiosIns.get('/payment_remarks', {params:queryParams})
          .then(response => resolve(response))
          .catch(error => reject(error))
        })
    },
    addPaymentRemark(ctx, data) {
        return new Promise((resolve, reject) => {
            axiosIns.post('/payment_remarks', data)
            .then(response => resolve(response))
            .catch(error => reject(error))
        })
    },
    deletePaymentRemark(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns.delete('/payment_remarks', {params:data})
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
